import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IncomeAuditService } from '../services/income-audit.service';
import { AuditCompletedVerification } from '../models/income-audit.models';
import { AuditReviewModalComponent } from '../audit-review-modal/audit-review-modal.component';

@Component({
  selector: 'app-audit-landing',
  templateUrl: './audit-landing.component.html',
  styleUrls: ['./audit-landing.component.less'],
})
export class AuditLandingComponent implements OnInit {
  items: AuditCompletedVerification[] = [];
  loading = true;
  error: string | null = null;

  // Pagination
  page = 1;
  pageSize = 50;
  totalCount = 0;

  // Filters
  filterProcessorId: number | null = null;
  filterDateFrom: string | null = null;
  filterDateTo: string | null = null;

  constructor(
    private auditService: IncomeAuditService,
    private modalService: NgbModal,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.loading = true;
    this.error = null;

    this.auditService
      .getCompletedVerifications(
        this.page,
        this.pageSize,
        this.filterProcessorId ?? undefined,
        this.filterDateFrom ?? undefined,
        this.filterDateTo ?? undefined
      )
      .subscribe({
        next: (res) => {
          this.items = res.items ?? [];
          this.totalCount = res.totalCount;
          this.loading = false;
        },
        error: () => {
          this.error = 'Failed to load completed verifications.';
          this.loading = false;
        },
      });
  }

  onPageChange(newPage: number): void {
    this.page = newPage;
    this.loadData();
  }

  onFilterApply(): void {
    this.page = 1;
    this.loadData();
  }

  onFilterClear(): void {
    this.filterProcessorId = null;
    this.filterDateFrom = null;
    this.filterDateTo = null;
    this.page = 1;
    this.loadData();
  }

  openReview(item: AuditCompletedVerification): void {
    const ref = this.modalService.open(AuditReviewModalComponent, {
      centered: true,
      size: 'lg',
      backdrop: 'static',
    });
    ref.componentInstance.screeningId = item.screeningId;
  }

  openScreening(screeningId: number): void {
    this.router.navigate(['/screenings/review', screeningId]);
  }

  formatDuration(seconds: number): string {
    if (!seconds || seconds <= 0) return '—';
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return m > 0 ? `${m}m ${s}s` : `${s}s`;
  }

  deltaPercent(item: AuditCompletedVerification): number | null {
    if (!item.totalSuggestedAmount || item.totalSuggestedAmount === 0) return null;
    return Math.round(((item.totalVerifiedAmount - item.totalSuggestedAmount) / item.totalSuggestedAmount) * 1000) / 10;
  }

  get totalPages(): number {
    return Math.ceil(this.totalCount / this.pageSize) || 1;
  }
}
